module.exports = __webpack_public_path__ + "b242eb0dba8fc6447e1c3b44a2f62539.png";